import de from '@/constants/zod/de.ts';
import en from '@/constants/zod/en.ts';
import pl from '@/constants/zod/pl.ts';
import sk from '@/constants/zod/sk.ts';

export default {
  en,
  de,
  pl,
  sk,
};
